
export const MINIAPP = {
    PAYTM: 'PAYTM',
    GPAY: 'GPAY'
};

export const PAYMENT_METHOD = {
    CITRUS_WALLET: 'PIGGYBANK',
    OTHER_WALLETS: 'CASHCRD',
    NET_BANKING: 'NB',
    EVOUCHER: 'EVOUCHER',
    CASH: 'CASH',
    CREDIT_CARD: 'CC',
    DEBIT_CARD: 'DC',
    AMAZON_WALLET: 'AMZPAY_WALLET',
    PAYTM_WALLET: 'PAYTM_WALLET',
    UPI_WALLET: 'UPI_WALLET',
    MOBILE_BANKING: 'MB',
    WALLET: 'WALLET'
  };
  
  export const PAYMENT_ACTION = {
    COD_OTP: 'COD_OTP',
    EV_PIN: 'EV_PIN',
    EV_OTP: 'EV_OTP',
    REDIRECT: 'REDIRECT',
    AMZNPAY_CHARGE_STATUS: 'AMZNPAY_CHARGE_STATUS',
    PROCESS_PAYMENT: 'PROCESS_PAYMENT',
    PAY_PAGE: 'PAY_PAGE',
    REMOVE_PROMO: 'REMOVE_PROMO',
    REFUND_PAGE: 'REFUND_PAGE',
    PAYTM_ADD_MONEY: 'PAYTM_ADD_MONEY',
    PAYTM_WITHDRAW_MONEY: 'PAYTM_WITHDRAW_MONEY',
    THANKYOU: 'THANKYOU',
    PAYTM_LINK: 'PAYTM_LINK',
    FAILED: 'FAILED',
    UNIFIED_PAYMENT: 'UNIFIED_PAYMENT_ACTION',
    DISPLAY_POLLING: 'DISPLAY_POLLING'
  };
  
  export const PAY_ENABLE_DISABLED = {
    ENABLED: 'E',
    DISABLED: 'D'
  };
  
  export const BANK_LABEL = {
    POPULAR_BANKS: 'Popular Banks',
    OTHER_BANK: 'Other Banks'
  };
  
  export const REDEEM_WALLET = {
    YES: 'y',
    NO: 'n'
  };
  
  export const PAYMENT_GATEWAY = {
    PAYU: 'PAYU',
    PAYTM_PG: 'PAYTM_PG',
    BILLDESK: 'BILLDESK',
    PAYTM_WALLET: 'PAYTM_WALLET',
    GLOBALPAY: 'GLOBALPAY',
    SSLCOMMERZ: 'SSLCOMMERZ',
    RAZORPAY: 'RAZORPAY'
  };
  
  export const MONTHS_ARRAY = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ];
  export const NUMBER_OF_YEARS = 15;
  export const UNAUTHORIZED_ACCESS = 'Unauthorized_access';
  export const IRCTC_DATA = {
    HOME: 'Home',
    TEST: 'test',
    DELIVERY_TYPE: 'D'
  };
  
  // For thge UPI Intent
  export const STORE_UPI_INTENT_RESULT = 'STORE_UPI_INTENT_RESULT';
  export const PAYMENT_VERIFY_CHARGE_STATUS = 'PAYMENT_VERIFY_CHARGE_STATUS';
  export const PAYMENT_VERIFY_CHARGE_STATUS_NEXTGEN =
    'PAYMENT_VERIFY_CHARGE_STATUS_NEXTGEN';
  export const PROCESS_PAYMENT = 'PROCESS_PAYMENT';
  export const OPEN_UPI_INTENT = 'OPEN_UPI_INTENT';
  export const HIDE_UPI_INTENT = 'HIDE_UPI_INTENT';
  export const UPI_TRANSACTION_ERROR = 'UPI_TRANSACTION_ERROR';
  export const CONFIRM_UPI_PAYMENT = 'CONFIRM_UPI_PAYMENT';
  
  export const EXCLUDE_TIP_PAYMENT_MODES = [
    PAYMENT_METHOD.CITRUS_WALLET,
    PAYMENT_METHOD.CASH
  ];
  
  export const INTENT_FLOW = 'INTENT';
  export const COLLECT_FLOW = 'COLLECT';
  export const UNIFIED = 'unified';
  
  export const UNIFIED_ACTION = {
    POLL: 'poll',
    OTP: 'otp',
    REDIRECT: 'redirect',
    INTENT: 'intent',
    OTPRETRY: 'otp_retry',
    BASE64ENCODED: 'base64Encoded',
    LINKUSER: 'link_user',
    PAYMENTLOADER: 'payment_wait_loader',
    PG_SDK: 'pg_sdk_hash'
  };
  